import React, { Component } from 'react';

import { translateStaticContent } from '../../../helpers/translateStaticContent';
import PropTypes from 'prop-types';
import axios from '../../../axios/axios';
import SearchAddressItem from './SearchAddressItem';

class Search extends Component  {
    constructor(props) {
        super(props);
    
         this.state = {
           searchValue: '',
           searchAddress: [],
         }
       }
    
       onChangeHandler = (e) => {
        const value = e.target.value;
        this.setState({...this.state, searchValue: value})
    
        const apiKey = 'AIzaSyAXVoume29wml8rFbbb_cFT2miwjGBvumE';
        const activeLang = this.props.activeLang ? this.props.activeLang : 'uk';
        if (value.length >= 3) {
          return new Promise((resolve) => {
            const url = `maps/api/geocode/json?address=${value}&language=${activeLang}&key=${apiKey}`;
            axios.get(url)
            .then(res => this.listOfSearchAddress(res.data.results))
            .catch((e) => {
                console.log('Error in getAddress', e)
                resolve()
              })
          })
        } else if(value.length == 0) {
            this.setState({...this.state, searchValue: '', searchAddress: []
          })
          this.props.showCurrentLocation();
        }
      }

      selectedAdress = (location, address) => {
        this.setState({...this.state, searchAddress: [], searchValue: address}, () => this.props.selectedAdress(location, address));
      }

      listOfSearchAddress = (addresses) => {
        const listOfAddresses = addresses.map(address => {
          return <SearchAddressItem key={address.place_id} 
                                    address={address.formatted_address} 
                                    selectedAdress={this.selectedAdress}
                                    location={address.geometry.location}/>
        })
        this.setState({...this.state, searchAddress: listOfAddresses})
      }

    render() {
        const isShowAddress = this.state.searchAddress.length > 0 ? 'show' : '';
        const staticSearchPlaceholder = translateStaticContent('searchPlaceholder', 
                                        this.props.defaultStaticContentMap, this.props.activeLangStaticContentMap);
        return (
            <div className="status-field">
                <input type="text" id='inputAddress'
                    placeholder={staticSearchPlaceholder}
                    value={this.state.searchValue}
                    onChange={this.onChangeHandler}
                />
                <label htmlFor="inputAddress"></label>
                <ul className={`${isShowAddress}`}>
                    {this.state.searchAddress}
                </ul>
            </div>
        )
    } 
}

export default Search;

Search.propTypes = {
    defaultStaticContentMap: PropTypes.object,
    activeLangStaticContentMap: PropTypes.object,
    activeLang: PropTypes.string,
    selectedAdress: PropTypes.func,
    showCurrentLocation: PropTypes.func,
  }
  